import { render } from "./ResourceLayout.vue?vue&type=template&id=bc52d6e6&scoped=true"
import script from "./ResourceLayout.vue?vue&type=script&lang=js"
export * from "./ResourceLayout.vue?vue&type=script&lang=js"

import "./ResourceLayout.vue?vue&type=style&index=0&id=bc52d6e6&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc52d6e6"]])

export default __exports__